module.exports = __webpack_public_path__ + "static/media/chevron-down-icon.26e36bd1.svg";